<template>
  <Teleport to="body">
    <div class="howto-backdrop" @click.self="$emit('close')">
      <div class="howto guide deck-dialog" role="dialog" aria-modal="true" aria-label="Your deck">
        <button class="howto__close icon-button" aria-label="Close" @click="$emit('close')">×</button>
        <div class="howto__body">
          <h3>{{ pile === 'deck' ? 'Still to draw' : pile === 'discard' ? 'Played this time round' : 'Your deck' }}</h3>
          <!-- Which pile was tapped is which pile you see (Matt, playtest 13,
               twice: "tap on the discard pile and pull up just the cards in
               the discard"; the draw pile shows what is still to come - as
               a set, never in order). -->
          <div class="deck-dialog__tabs" role="tablist">
            <button v-for="t in TABS" :key="t.id" role="tab" :aria-selected="pile === t.id" :class="{ 'deck-dialog__tab--on': pile === t.id }" @click="pile = t.id">{{ t.label }} <small>{{ countOf(t.id) }}</small></button>
          </div>
          <p class="deck-dialog__note">
            <template v-if="pile === 'deck'">{{ hall.deck.length }} still to draw before the discard is shuffled back in. Which comes next is nobody's business.</template>
            <template v-else-if="pile === 'discard'">{{ hall.discard.length }} played or bought since the last shuffle; they come back when the draw pile runs out.</template>
            <template v-else>{{ total }} {{ total === 1 ? 'card' : 'cards' }} in all: {{ hall.deck.length }} still to come, {{ hall.hand.length }} in hand, {{ hall.discard.length }} already played this time round.</template>
          </p>
          <p v-if="!cards.length" class="deck-dialog__note">Nothing here.</p>
          <ul class="deck-dialog__grid">
            <li v-for="c in cards" :key="c.id">
              <HallCard :card="c" :count="c.count" small />
            </li>
          </ul>
          <template v-if="laws.length">
            <h4 class="hall__title">Standing laws</h4>
            <p class="deck-dialog__note">In force for good. No longer in the deck.</p>
            <ul class="deck-dialog__grid">
              <li v-for="c in laws" :key="c.id"><HallCard :card="c" small /></li>
            </ul>
          </template>
        </div>
        <div class="howto__nav">
          <span class="howto__dots" />
          <button class="primary howto__next" @click="$emit('close')">Close</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { hallOf } from '@/engine/hall';
import HallCard from './HallCard.vue';
import { faceFor } from './hallFaces';

// "It would also be nice if I could see my deck, if I could look through
// what's actually in the deck, because I have no idea what's possible."
//
// Everything you own, counted, in one place - deck, hand and discard
// together, because a deck-builder's deck is all three. The ORDER stays
// hidden: knowing what is in there is strategy, knowing what is next is
// not a game.
export default {
  name: 'DeckDialog',
  components: { HallCard },
  props: {
    civ: { type: Object, required: true },
    // 'deck' (still to draw), 'discard' (played this time round) or 'all'.
    open: { type: String, default: 'all' },
  },
  emits: ['close'],
  data() { return { pile: this.open, TABS: [{ id: 'deck', label: 'To draw' }, { id: 'discard', label: 'Played' }, { id: 'all', label: 'All' }] }; },
  computed: {
    hall() { return hallOf(this.civ) || { deck: [], hand: [], discard: [], laws: [] }; },
    total() { return this.hall.deck.length + this.hall.hand.length + this.hall.discard.length; },
    cards() {
      const all = this.pile === 'deck' ? [...this.hall.deck]
        : this.pile === 'discard' ? [...this.hall.discard]
          : [...this.hall.deck, ...this.hall.hand, ...this.hall.discard];
      const counts = all.reduce((acc, id) => ({ ...acc, [id]: (acc[id] || 0) + 1 }), {});
      return Object.entries(counts)
        .map(([id, count]) => ({ ...this.face(id), count }))
        .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));
    },
    laws() { return (this.hall.laws || []).map((id) => this.face(id)); },
  },
  methods: {
    countOf(id) { return id === 'deck' ? this.hall.deck.length : id === 'discard' ? this.hall.discard.length : this.total; },
    face(id) { return faceFor(this.civ, id); },
  },
};
</script>
